module.exports = __webpack_public_path__ + "img/head-img-tiyan.e871956e.png";